import Duck from 'extensible-duck';
import toast from 'simple-pure-toast';
import {get, post} from '../../utils/request';
import {
    convertDateFinish,
    convertDateInit,
    fechaActual,
    fechaInicial,
    handlerRequestErrors,
    msjCommon,
    statusesCommon,
    typesCommon
} from '../../utils/helpers';

const initialState = {
  message: '',
  status: '',
  loadingQuick: false,
  detailSaleQuick: []
};

const getInitialState = ({statuses}) => ({
  ...initialState,
  status: statuses.NEW
});

export default new Duck({
  namespace: 'converti',
  store: 'quick',
  consts: {
    statuses: [
      ...statusesCommon,
      'READY_LIST_QUICK',
      'SAVE_QUICK'
    ]
  },
  types: [
    ...typesCommon,
    'FETCH_FULLFILLED_LIST_QUICK',
    'POST_FULLFILLED_REGISTER_QUICK',
    'RESET_QUICK_DUCK'
  ],
  initialState: getInitialState,
  reducer: (state, action, { types, statuses }) => {
    switch (action.type) {
      case types.POST_FULLFILLED_REGISTER_QUICK:
        toast.success(msjCommon('listo'), { description: 'Se registró la acción Quick' });
        return {
          ...state,
          status: statuses.SAVE_QUICK
        };

      case types.FETCH_FULLFILLED_LIST_QUICK:
        return {
          ...state,
          detailSaleQuick: action.payload,
          status: statuses.READY_LIST_QUICK
        };

      case types.CREATOR_FAILD:
        toast.error(msjCommon('fallo'), { description: action.payload.message, position: 'bottomRight' });
        return { ...state, status: statuses.ERROR };

      case types.LOADING_EFFECT:
        return {
          ...state,
          loadingQuick: action.loadingQuick
        };

      case types.RESET_QUICK_DUCK:
        return getInitialState({ statuses })

      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state
  },
  creators: ({ types }) => ({
    getSaleDetailQuick: (filters = {}) => async (dispatch, getState) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingQuick: true });
        const {
          auth: {
            rolActual, rol,
            user: { userId }
          }
        } = getState();
        const { payload } = await get(
          `/acciones-quick`,
          {
            queryStringParameters: {
              idCreador: (rolActual === rol.asesor || filters.idCreador === null)
                  ? null
                  : filters.idCreador === undefined
                      ? userId
                      : filters.idCreador,
              idAsignado: rolActual === rol.asesor ? userId : filters.idAsignado,
              fechaInicio: filters.fec_inicio ? convertDateInit(filters.fec_inicio) : convertDateInit(fechaInicial),
              fechaFin: filters.fec_fin ? convertDateFinish(filters.fec_fin) : convertDateFinish(fechaActual)
            }
          }
        );
        dispatch({ type: types.FETCH_FULLFILLED_LIST_QUICK, payload });
        dispatch({ type: types.LOADING_EFFECT, loadingQuick: false });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingQuick: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    registerQuick: (requestPayload = {}) => async (dispatch) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingQuick: true });
        const json = { payload: requestPayload };
        const { payload } = await post('/acciones-quick', json);
        dispatch({ type: types.POST_FULLFILLED_REGISTER_QUICK, payload });
        dispatch({ type: types.LOADING_EFFECT, loadingQuick: false });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingQuick: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    resetQuickDuck: () => async (dispatch) => {
      dispatch({ type: types.RESET_QUICK_DUCK });
    }

  })
});
